import React from "react"
import ReactTable from "react-table"
import checkboxHOC from 'react-table/lib/hoc/selectTable'
import "react-table/react-table.css"
import { getParams, end_point } from './helper'
import { Chart } from 'react-google-charts'
import HamburgerNavbar from './hamburgerNavbar'
import EnrolmentTracker from './enrolmentTracker'
import EnrolmentTracker2 from './EnrolmentTracker2'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { FormGroup, ControlLabel, FormControl, Button, Tabs, Tab, Row, Col } from 'react-bootstrap'
import { textAlign } from "@material-ui/system"

var $ = require('jquery')

const CheckboxTable = checkboxHOC(ReactTable)

const getMonth = {
  "1": "Jan",
  "2": "Feb",
  "3": "Mar",
  "4": "Apr",
  "5": "May",
  "6": "Jun",
  "7": "Jul",
  "8": "Aug",
  "9": "Sep",
  "10": "Oct",
  "11": "Nov",
  "12": "Dec",
  "0": "Dec"
};

const normalizeRevenueType = (type) => {
  const normalized = (type || '').toString().trim().toLowerCase()

  if (['house league', 'houseleague', 'internal league', 'internalleague', 'league'].includes(normalized)) {
    return 'league'
  }

  if (['club team', 'clubteam', 'club-team'].includes(normalized)) {
    return 'club team'
  }

  if (['skill session', 'skillsession', 'skill-session', 'skills', 'skill'].includes(normalized)) {
    return 'skill session'
  }

  if (['camp', 'camps'].includes(normalized)) {
    return 'camp'
  }

  if (['private', 'privates'].includes(normalized)) {
    return 'private'
  }

  return normalized
}

class AdminPortalDashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      token: getParams().jwt,
      organization_id: localStorage.getItem("organization_id"),
      data: [],
      selection: [],
      selectAll: false,
      current_month: new Date().getMonth() + 1,
      all_monthly_data: [],
      projected_enrolment_map : {},
      shirt_map: [], // first value is projected_length, second is prejected_enrolment, third is current on hand, fourth is quantity to order, fifth is cost
      short_map: [],
      hood_map: [],
      show_shirt: false,
      show_short: false,
      show_hood: false,
// MCTRACKER
      show_tracker_ytd: false,
      show_tracker_all_time: false,
// MCTRACKER
      monthly_new_enrollments: {"1": 0, "2": 0, "3":0, "4": 0, "5": 0, "6": 0,
                                "7": 0, "8": 0, "9":0, "10": 0, "11":0, "0": 0},
      monthly_returning_enrollments: {"1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0,
                                "7": 0, "8": 0, "9": 0, "10": 0, "11": 0, "0": 0},
      get_all_programs_endpoint: `${end_point('programs')}/programs`,
      get_monthly_transactions_endpoint: `${end_point()}/monthly_board`,
      get_transactions_endpoint: `${end_point('transactions')}/transactions`,
      coach_map: {},
      enrollment_goal: null,
      number_of_enrollments: null,
      ytd_count: null,
      all_count: null,
      today_registration_count: null,
      today_revenue: null,
      monthly_registration_count: null,
      monthly_revenue: null,
      programRevenue: null,
      transactionMap: {},
      totalRevenue: {camp: null, league: null, clubTeam: null, skillSession: null, private: null},
      secondDonut: [["Status", "Value",  {type: 'string', role: 'tooltip'}]],
      merch_map: [{'name': 'item_0'},{'name': 'item_1'},{'name': 'item_2'}],
      colors: {
        new: '#f3ccb8',
        returning: '#F5E7C5',
        enrolled: '#74B495',
        goal: '#877FD7',
        waitlist: '#02BCFB',
        invited: '#EA417A',
        camp: '#776d17',
        league: '#016445',
        skillSession: '#BC8358',
        private: '#01FFDD',
        clubTeam: '#CF37D8'
      },
      loading_transactions: false,
    }
  }

  toggleSelection = (key, shift, row) => {
    let selection = [ ...this.state.selection ];
    const rowIndex = selection.indexOf(row);
    if (rowIndex >= 0) {
      selection = [
        ...selection.slice(0, rowIndex),
        ...selection.slice(rowIndex + 1)
      ]
    } else {
      selection.push(row);
    }

    var program_ids = [];
    selection.forEach((program) => {
      program_ids.push(program._id)
    })

    if(selection.length === 0){
      this.calculateEnrolledWaitlistInvited()
      this.setState({ programRevenue: null})
    } else {
      this.calculateEnrolledWaitlistInvited(program_ids)
      this.calculateProgramRevenue(program_ids)
    }
    this.setState({ selection });
    this.sortMonthlyEnrollment(this.state.all_monthly_data, program_ids);
    this.sortEnrollmentGoal(this.state.data, program_ids);
  }

  toggleAll = () => {
    const selectAll = this.state.selectAll ? false : true;
    const selection = [];
    if (selectAll) {
      const wrappedInstance = this.checkboxTable.getWrappedInstance();
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      currentRecords.forEach((item) => {
          selection.push(item._original);
      })
      this.calculateEnrolledWaitlistInvited("all")
    } else {
      this.calculateEnrolledWaitlistInvited()
    }
    this.setState({ selectAll, selection, programRevenue: null })
    this.sortMonthlyEnrollment(this.state.all_monthly_data, [])
    this.sortEnrollmentGoal(this.state.data, [])
  }

  isSelected = (key) => {
    return this.state.selection.find((element) => {
      return element._id === key;
    }) ? true : false;
  }

  calculateProgramRevenue = (programs) => {
    var programRevenue = []
    programRevenue.push(['Program Name', 'Revenue', {type: 'string', role: 'tooltip'}])
    programs.forEach( program => {
      if (this.state.transactionMap[program]) {
        programRevenue.push([ this.state.transactionMap[program].group_name, this.state.transactionMap[program].revenue,
          `${this.state.transactionMap[program].ages} | ${this.state.transactionMap[program].division} 
          ${this.state.transactionMap[program].group_name}
          $${this.state.transactionMap[program].revenue.toFixed(2)}` 
        ])
      }
    })
    this.setState({ programRevenue })
  }

  calculateEnrolledWaitlistInvited = (programs = []) => {
    var enrolled = 0
    var waitlist = 0
    var invited = 0 
    var secondDonut = [['Status', 'Number',  {type: 'string', role: 'tooltip'}]]
    if (programs.length === 0) {
      //calculate all 
      this.state.data.forEach(program => {
        //get YTD on program start date
        if (new Date(program.start_date).getFullYear() === (new Date()).getFullYear()) {
          enrolled += program.enrollment_total 
          waitlist += program.enrollment_waitlist
          invited += program.enrollment_invited
        }
      })
    } else if (programs === 'all') {
      this.state.data.forEach(program => {
        //get YTD on program start date
        enrolled += program.enrollment_total 
        waitlist += program.enrollment_waitlist
        invited += program.enrollment_invited
      })
    } else {
      programs.forEach(selectedProgram => {
        this.state.data.forEach(program => {
          if(selectedProgram === program._id){
            enrolled += program.enrollment_total 
            waitlist += program.enrollment_waitlist
            invited += program.enrollment_invited
          }
        })
      })
    }
  secondDonut.push(['Enrolled', enrolled, `Enrolled: ${enrolled}`])
  secondDonut.push(['Waitlist', waitlist, `Waitlist: ${waitlist}`])
  secondDonut.push(['Invited', invited, `Invited: ${invited}`])
  this.setState({ secondDonut })
  }

  async loadTransactions(skip) {
    return await $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "skip": skip
      },
      method: "GET",
      dataType: "json",
      url: `${this.state.get_transactions_endpoint}?dashboard=true`,
    });
  }

  async loadAllTransactions() {
    this.setState({loading_transactions: true})
    const results = [];
    let skip = 0;
    let latestResults = [];
    while (skip === 0 || latestResults?.length > 0) {
      latestResults = await this.loadTransactions(skip);
      if (!Array.isArray(latestResults)) {
        throw new Error('Transactions endpoint returned a non-array response')
      }
      skip+=latestResults.length;
      results.push(...latestResults);
    }
    this.setState({loading_transactions: false})
    return results;
  }

  componentDidMount() {
    var rthis = this;
    document.title = 'Organization Dashboard';
    console.log('admin portal componentdidmnt org:', this.state.organization_id)
    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "user_type": "coachadmin"
      },
      method: "GET",
      dataType: "json",
      url: `${end_point('users')}/users`
    }).then(data => rthis.handleCoach(data.message));

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id
      },
      method: "GET",
      dataType: "json",
      url: `${end_point('organizations')}/organizations`
  
    }).then(data => { rthis.setState({ merch_map: data.merch}) });


    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "function": "get_monthly_transactions"
      },
      method: "GET",
      contentType: 'application/json',
      dataType: "json",
      url: this.state.get_monthly_transactions_endpoint,
    }).then(data => {
      rthis.setState({ all_monthly_data: data.message || [] }, () => {
        rthis.sortMonthlyEnrollment(data.message || [])
      })
    })

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "function": "get_enrolment_count"
      },
      method: "GET",
      contentType: 'application/json',
      dataType: "json",
      url: this.state.get_monthly_transactions_endpoint,
    }).then(data => {
        rthis.setState({
          ytd_count: data.message.ytd_count, 
          all_count: data.message.all_count
        })
      })

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "function": "get_revenue_summary"
      },
      method: "GET",
      contentType: 'application/json',
      dataType: "json",
      url: this.state.get_monthly_transactions_endpoint,
    }).then(data => rthis.handleRevenueSummary(data.message || {}))


    // $.ajax({
    //   headers: {
    //     "token": this.state.token,
    //     "organization_id": this.state.organization_id
    //   },
    //   method: "GET",
    //   dataType: "json",
    //   url: this.state.get_transactions_endpoint,
    // }).then(data => rthis.handleRevenue(data))
    this.loadAllTransactions()
        .then(data => rthis.handleRevenue(data))

  }

  componentWillUnmount() {
    document.title = 'Hoopstir';
  }

  handleRevenueSummary(summary) {
    this.setState({
      totalRevenue: summary.totalRevenue || this.state.totalRevenue,
      today_registration_count: summary.today_registration_count,
      today_revenue: summary.today_revenue,
      monthly_registration_count: summary.monthly_registration_count,
      monthly_revenue: summary.monthly_revenue,
    })
  }

    handleRevenue(data){
      console.log('handleRevenue data:', data)

      var transactionMap = {}
      var camp = 0;
      var league = 0;
      var club_team = 0;
      var skill_session = 0;
      var type_private = 0;
      var today_registration_count = 0;
      var today_revenue = 0;
      var monthly_revenue = 0;
      let ignoredTransactionStatuses = ['unverified', 'unpaid', 'waitlist']
      const today = new Date()

      data.forEach(transaction => {
        if (!transaction.program) {
          return
        }

        const transactionTotal = Number(transaction.price_breakdown && transaction.price_breakdown.total) || 0
        const transactionStatus = transaction.payment_gateway && transaction.payment_gateway.status
          ? transaction.payment_gateway.status.status
          : null
        const revenueType = normalizeRevenueType(transaction.program.type_bucket || transaction.program.type)

        if (!ignoredTransactionStatuses.includes(transactionStatus)) {
          const transactionDate = new Date(transaction.create_date)
          if (
            transactionDate.getFullYear() === today.getFullYear() &&
            transactionDate.getMonth() === today.getMonth() &&
            transactionDate.getDate() === today.getDate()
          ) {
            today_registration_count += 1
            today_revenue += transactionTotal
          }
          if (
            transactionDate.getFullYear() === today.getFullYear() &&
            transactionDate.getMonth() === today.getMonth()
          ) {
            monthly_revenue += transactionTotal
          }
          // Ignore EF2 legacy rows; they use `programs/details` instead of `program`.
          if(transactionMap.hasOwnProperty(transaction.program._id)){
            transactionMap[transaction.program._id].revenue = transactionMap[transaction.program._id].revenue + transactionTotal
          } else {
            transactionMap[transaction.program._id] = {}
            transactionMap[transaction.program._id].revenue = transactionTotal
            transactionMap[transaction.program._id].type = revenueType
            transactionMap[transaction.program._id].ages = transaction.program.ages
            transactionMap[transaction.program._id].division = transaction.program.division
            transactionMap[transaction.program._id].group_name = transaction.program.group_name
          }
          if(revenueType && transactionStatus !== 'unverified'
              && (new Date(transaction.create_date)).getFullYear() === (new Date()).getFullYear() ){
            if(revenueType === "camp"){
              camp = camp + transactionTotal;
            } else if(revenueType === "league") {
              league = league + transactionTotal
            } else if(revenueType === "club team"){
              club_team = club_team + transactionTotal;
            } else if(revenueType === "skill session"){
              skill_session = skill_session + transactionTotal;
            } else if(revenueType === "private"){
              type_private = type_private + transactionTotal;
            }
          }
        }
      })

      var totalRevenue = {
        camp, league, clubTeam: club_team, skillSession: skill_session, private: type_private
      }
      console.log('what is total revenue now:', totalRevenue)
      this.setState({
        totalRevenue, 
        transactionMap,
        today_registration_count,
        today_revenue,
        monthly_revenue
      })
    }

    handleCoach(data) {
      var coach_container = {}
      data.forEach(coach => {
        coach_container[coach["_id"]] = `${coach["first_name"]} ${coach["last_name"]}`
      })
      this.setState({ coach_map: coach_container }, () => {
        this.getAllProgram();
      })
    }

    getAllProgram(){
      $.ajax({
          headers: {
            "token": this.state.token,
            "organization_id": this.state.organization_id
          },
          method: "GET",
          dataType: "json",
          url: this.state.get_all_programs_endpoint,
      }).then(data =>
        {
          this.programsGetHandler(data);
          this.sortEnrollmentGoal(data.message);
        }
      );
    }



    filterMethod = (filter, row) => {
      const id = filter.pivotId || filter.id;
      if (row[id] !== null && typeof row[id] === "string") {
        return (row[id] !== undefined
          ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
          : true)
        } else if (row[id] !== null && typeof row[id] === "number"){
          if (String(row[id]).includes(String(filter.value))) {
            return true
          } else {
            return false
          }
        }
      }

    sortEnrollmentGoal(data, programArray = []){
      var temp_enrollment_goal = 0;
      var temp_number_of_enrollments = 0;
      if(programArray.length !== 0){
        programArray.forEach(program => {
          data.forEach(goal => {
            if(program === goal._id){
              temp_enrollment_goal = temp_enrollment_goal + goal.enrollment_goal;
              temp_number_of_enrollments = temp_number_of_enrollments + goal.enrolled_users.length;
            }
          })
        })
      } else {
        data.forEach(goal => {
          temp_enrollment_goal = temp_enrollment_goal + goal.enrollment_goal;
            temp_number_of_enrollments = temp_number_of_enrollments + goal.enrolled_users.length;
        })
      }
      this.setState({ enrollment_goal: temp_enrollment_goal - temp_number_of_enrollments,
                      number_of_enrollments: temp_number_of_enrollments})
    }

    sortMonthlyEnrollment = (data, programArray = []) => {
      const monthlyData = Array.isArray(data) ? data : []
      const currentMonthKey = new Date().getMonth() + 1 === 12 ? "0" : String(new Date().getMonth() + 1)
      var temp_monthly_new_enrollments = {"1": 0, "2":0, "3":0, "4":0, "5":0, "6":0,
      "7": 0, "8":0, "9":0, "10":0, "11":0, "0": 0};
      var temp_monthly_returning_enrollments = {"1": 0, "2":0, "3":0, "4":0, "5":0, "6":0,
      "7": 0, "8":0, "9":0, "10":0, "11":0, "0": 0};
      var monthly_registration_count = 0;

      
      if(programArray.length !== 0){
           programArray.forEach((program) => {
           monthlyData.forEach((event) =>{
             if(event["_id"].program_id === program && event["_id"].returning_user === false){
               if (String(event["_id"].month) === currentMonthKey) {
                 monthly_registration_count += event["count"]
               }
               event["_id"].month === 12 ? temp_monthly_new_enrollments["0"] = temp_monthly_new_enrollments["0"] + event["count"]: temp_monthly_new_enrollments[event["_id"].month] = temp_monthly_new_enrollments[event["_id"].month] + event["count"]
             } else if (event["_id"].program_id === program && event["_id"].returning_user === true){
               if (String(event["_id"].month) === currentMonthKey) {
                 monthly_registration_count += event["count"]
               }
               event["_id"].month === 12 ? temp_monthly_returning_enrollments["0"] = temp_monthly_returning_enrollments["0"] + event["count"]: temp_monthly_returning_enrollments[event["_id"].month] = temp_monthly_returning_enrollments[event["_id"].month] + event["count"]
             }
           })
         })
      } else {
        monthlyData.forEach((enrollments =>
        {
          if (String(enrollments["_id"].month) === currentMonthKey) {
            monthly_registration_count += enrollments["count"]
          }
          if(enrollments["_id"].returning_user === false){
            enrollments["_id"].month === 12 ? temp_monthly_new_enrollments["0"] = temp_monthly_new_enrollments["0"] + enrollments["count"]: temp_monthly_new_enrollments[enrollments["_id"].month] = temp_monthly_new_enrollments[enrollments["_id"].month] + enrollments["count"]
          } else {
            enrollments["_id"].month === 12 ? temp_monthly_returning_enrollments["0"] = temp_monthly_returning_enrollments["0"] + enrollments["count"]: temp_monthly_returning_enrollments[enrollments["_id"].month] = temp_monthly_returning_enrollments[enrollments["_id"].month] + enrollments["count"]
          }
        }
      ))
     }
     this.setState({
       monthly_new_enrollments: temp_monthly_new_enrollments,
       monthly_returning_enrollments: temp_monthly_returning_enrollments,
       monthly_registration_count
     })
    }

    programsGetHandler(resp) {
        if(resp.errorMessage){
            window.location.href = document.location.origin + "/login";
        }
        else{
            var temp_array = resp.message;
            const month_chart = {"01": "Jan", "02": "Feb",
                                 "03": "Mar", "04": "Apr",
                                 "05": "May", "06": "Jun",
                                 "07": "Jul", "08": "Aug",
                                 "09": "Sept", "10": "Oct",
                                 "11": "Nov", "12": "Dec"}
            temp_array.forEach( data => {
              var item_0_count = 0;
              var item_1_count = 0;
              var item_2_count = 0;
              data.enrolled_users.forEach(user =>{
                if(user.merch && user.merch.item_0 !== false){
                  item_0_count += 1
                }
                if(user.merch && user.merch.item_1 !== false){
                  item_1_count += 1
                }
                if(user.merch && user.merch.item_2 !== false){
                  item_2_count += 1
                }

              })
              var head_coach_id = data["head_coach"];
              data["head_coach"] = this.state.coach_map[head_coach_id]
              data.item_0_count = item_0_count
              data.item_1_count = item_1_count
              data.item_2_count = item_2_count
              var enrollment_waitlist = 0
              var enrollment_invited = 0
              var enrollment_total = 0
              data.enrolled_users.forEach( athlete => {
                if(!athlete.status || athlete.status === 'enrolled') {
                  enrollment_total += 1
                } else if (athlete.status === 'waitlist') {
                  enrollment_waitlist += 1
                } else if (athlete.status === 'invited') {
                  enrollment_invited += 1
                }
              })
              data.enrollment_waitlist = enrollment_waitlist
              data.enrollment_total = enrollment_total
              data.enrollment_invited = enrollment_invited
              //data.enrolment_total = data.enrolled_users.length
              data.create_date = `${month_chart[data.create_date.slice(5,7)]} ${data.create_date.slice(8,10)}, ${data.create_date.slice(0,4)}`;
              data.registration_start_date = `${month_chart[data.registration_start_date.slice(5,7)]} ${data.registration_start_date.slice(8,10)}, ${data.registration_start_date.slice(0,4)}`;
              data.registration_end_date = `${month_chart[data.registration_end_date.slice(5,7)]} ${data.registration_end_date.slice(8,10)}, ${data.registration_end_date.slice(0,4)}`;
              data.start_date = `${month_chart[data.start_date.slice(5,7)]} ${data.start_date.slice(8,10)}, ${data.start_date.slice(0,4)}`;
              data.end_date = `${month_chart[data.end_date.slice(5,7)]} ${data.end_date.slice(8,10)}, ${data.end_date.slice(0,4)}`;
            })
            this.setState({ data: temp_array });
        }
        this.calculateEnrolledWaitlistInvited()
        this.calculateProjectedEnrolment(resp.message);
    }

    calculateProjectedEnrolment(resp){
      var current = new Date();
      var one_month = new Date();
      var two_month = new Date();
      var six_month = new Date();
      var one_month_enrolment = 0;
      var two_month_enrolment = 0;
      var six_month_enrolment = 0;
      one_month.setMonth(one_month.getMonth() + 1)
      two_month.setMonth(two_month.getMonth() + 2)
      six_month.setMonth(six_month.getMonth() + 6)

      resp.forEach( (program ,index) => {
        var start_date = new Date(program.start_date);
        start_date.setDate(start_date.getDate() + 1)
        if(current <= start_date && start_date <= one_month){
          one_month_enrolment += program.enrollment_goal;
          two_month_enrolment += program.enrollment_goal;
          six_month_enrolment += program.enrollment_goal;
        } else if (current <= start_date && start_date <= two_month){
          two_month_enrolment += program.enrollment_goal;
          six_month_enrolment += program.enrollment_goal
        } else if (current <= start_date && start_date <= six_month){
          six_month_enrolment += program.enrollment_goal
        }
      })
      var projected_enrolment_map =[];
      projected_enrolment_map.push(one_month_enrolment);
      projected_enrolment_map.push(two_month_enrolment);
      projected_enrolment_map.push(six_month_enrolment);


      this.setState({ projected_enrolment_map: projected_enrolment_map,
                      shirt_map: [0, one_month_enrolment, 0, one_month_enrolment, this.getTotalCost("shirt_map", one_month_enrolment) ],
                      hood_map: [0, one_month_enrolment, 0, one_month_enrolment, this.getTotalCost("hood_map", one_month_enrolment) ],
                      short_map: [0, one_month_enrolment, 0, one_month_enrolment, this.getTotalCost("short_map", one_month_enrolment) ]})
    }

    getEnrolledvsGoal = () => {
      const { data, selection } = this.state 
      var enrolled = 0
      var goal = 0
      var returnVal = []
      if(selection.length === 0 ){
        data.forEach(program => {
          if(new Date(program.start_date).getFullYear() === (new Date()).getFullYear()){
          enrolled += program.enrollment_total
          goal += program.enrollment_goal
          }
        })
      } else {
        selection.forEach(program => {
          enrolled += program.enrollment_total
          goal += program.enrollment_goal
        })
      }

      if(enrolled >= goal ){
        returnVal = [
          ["Type", "Value", {type: 'string', role: 'tooltip'}],
          ["Enrolled", enrolled, `Enrolled: ${enrolled}
                                  Goal: ${goal}`],
          ["Goal", 0, `Goal: ${goal}`]
        ]
      } else {
        returnVal = [
          ["Type", "Value", {type: 'string', role: 'tooltip'}],
          ["Enrolled", enrolled, `Enrolled: ${enrolled}`],
          ["Goal", goal, `Goal: ${goal}`]
        ]
      }

      return returnVal
    }

    merchOnClick = (type) => {
      this.setState({[type]: !this.state[type]})
    }

    getTotalCost(type, quantity){
      if(type === "shirt_map"){
        if(quantity <= 25) {
          return 14 * quantity
        } else if(quantity <= 50){
          return 13.5 * quantity
        } else {
          return 12 * quantity
        }
      } else if (type === "short_map"){
        if(quantity <= 25) {
          return 22 * quantity
        } else if(quantity <= 50){
          return 21 * quantity
        } else {
          return 19 * quantity
        }
      } else if (type === "hood_map"){
        if(quantity <= 25) {
          return 33 * quantity
        } else if(quantity <= 50){
          return 31 * quantity
        } else {
          return 29 * quantity
        }
      }
    }

    onChangeProjectedEnrolmentLength = (event, type) => {
      var temp_arr = this.state[type];
      temp_arr[0] = event.target.value;
      temp_arr[1] = this.state.projected_enrolment_map[event.target.value];
      temp_arr[3] = this.state.projected_enrolment_map[event.target.value] - temp_arr[2]
      temp_arr[4] = this.getTotalCost(type, temp_arr[3])
      this.setState({ [type]: temp_arr});
    }

    onChangeCurrentOnHand = (event, type) => {
      var temp_arr = this.state[type];
      temp_arr[2] = event.target.value;
      temp_arr[3] = temp_arr[1] - temp_arr[2];
      temp_arr[4] = this.getTotalCost(type, temp_arr[3])
      this.setState({ [type]: temp_arr});
    }

    onQuantityToOrder(event, type){
      var temp_arr = this.state[type];
      temp_arr[3] = event.target.value;
      temp_arr[4] = this.getTotalCost(type, temp_arr[3])
      this.setState({ [type]: temp_arr});
    }

    onOrderNowClick = (type) => {
      var item = null;
      if(type === "shirt_map"){
        item = "shirts"
      } else if (type === "short_map"){
        item = "shorts"
      } else {
        item = "hoodies"
      }

      if(window.confirm(`Please confirm the order of ${this.state[type][3]} ${item} for the amount of $${this.state[type][4]}`)){
        $.ajax({
          headers: {
            "token": this.state.token,
            "organization_id": this.state.organization_id,
            "function": "email_order"
          },
          method: "GET",
          contentType: 'application/json',
          url: this.state.get_monthly_transactions_endpoint+`?content=${this.state[type]}&type=${type}`,
          success: (result) => {
            if(result.message){
              alert("Your order has been sent");
            } else {
              alert("Please contact support");
            }
          },
          error: (result) => {
            alert("Please contact support");
          }
        })
      }
    }


    showMerch(type){
      return(
        <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
          <Tab eventKey={1} title="Calculator" bsClass="white-text">
            <br/>
            <div>
              <Row>
                <FormGroup>
                  <Col sm={8} className="merchDash white-text">
                    <ControlLabel>Projected Enrolment</ControlLabel>
                    <form className="range-field">
                      <input type="range" min="0" max="2" step="1" onChange={e => this.onChangeProjectedEnrolmentLength(e, type)} value={this.state[type][0]}/>
                    </form>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                      <div>
                        1 mo
                      </div>
                      <div>
                        2 mo
                      </div>
                      <div>
                        6 mo
                      </div>
                    </div>
                  </Col>
                  <Col sm={4} style={{paddingRight: "10%"}}>
                    <FormControl
                      autoFocus
                      value={this.state[type][1]}
                      className="bottom-line"
                      name="projected_enrolment"
                      id="projected_enrolment" />
                  </Col>
                </FormGroup>
              </Row><br/>
              <Row>
                <FormGroup>
                  <Col sm={8} className="merchDash white-text">
                    <ControlLabel>Current On-Hand</ControlLabel>
                  </Col>
                  <Col sm={4} style={{paddingRight: "10%"}}>
                    <FormControl
                      autoFocus
                      className="bottom-line"
                      value={this.state[type][2]}
                      onChange={e => this.onChangeCurrentOnHand(e, type)}
                      name="current_on_hand"
                      id="current_on_hand" />
                  </Col>
                  </FormGroup>
              </Row><br/>
              <Row>
                <FormGroup>
                    <Col sm={8} className="merchDash white-text">
                      <ControlLabel>Quantity to Order</ControlLabel>
                    </Col>
                    <Col sm={4} style={{paddingRight: "10%"}}>
                      <FormControl
                        autoFocus
                        className="bottom-line"
                        name="to_order"
                        value={this.state[type][3]}
                        id="to_order" />
                    </Col>
                  </FormGroup>
              </Row><br/>
              <Row>
                <FormGroup>
                  <Col sm={6} className="merchDash white-text">
                    <ControlLabel>Cost</ControlLabel>
                  </Col>
                  <Col sm={5} className="pull-right" style={{display:"flex", alignItems: "center", paddingRight: "10%"}}>
                    <div className="white-text">$</div>
                    <FormControl
                        autoFocus
                        className="bottom-line"
                        name="cost"
                        value={this.state[type][4]}
                        id="cost" />
                  </Col>
                </FormGroup>
              </Row><br/>
              <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                  <Col sm={8}>
                    <Button className="orange-outline" type="button" onClick={e => this.onOrderNowClick(type)}>Order Now</Button>
                  </Col>
                </div><br/>
            </div>
          </Tab>
          <Tab eventKey={2} title="Custom">
            <br/>
            <div>
              <Row>
                <FormGroup>
                  <Col sm={8} className="merchDash white-text">
                    <ControlLabel>Quantity to Order</ControlLabel>
                  </Col>
                  <Col sm={4} style={{paddingRight: "10%"}}>
                    <FormControl
                      autoFocus
                      className="bottom-line"
                      name="to_order"
                      value={this.state[type][3]}
                      onChange={e => this.onQuantityToOrder(e, type)}
                      id="to_order-custom" />
                  </Col>
                </FormGroup>
              </Row><br/>
              <Row>
                <FormGroup>
                  <Col sm={6} className="merchDash white-text">
                    <ControlLabel>Cost</ControlLabel>
                  </Col>
                  <Col sm={5} className="pull-right" style={{display:"flex", alignItems: "center", paddingRight: "10%"}}>
                  <div className="white-text">$</div>
                  <FormControl
                    autoFocus
                    className="bottom-line"
                    name="cost"
                    value={this.state[type][4]}
                    id="cost-custom" />
                  </Col>
                  </FormGroup>
              </Row><br/>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "center"}}>
                <Col sm={8}>
                  <Button className="orange-outline" type="button" onClick={e => this.onOrderNowClick(type)}>Order Now</Button>
                </Col>
              </div><br/>
            </div>
          </Tab>
        </Tabs>
      )
    }

    render() {
      const { toggleSelection, toggleAll, isSelected } = this;
      const { data, 
              selectAll, 
              current_month, 
              merch_map, 
              programRevenue, 
              secondDonut, 
              show_hood, 
              show_short, 
              show_shirt, 
              totalRevenue, 
              colors, 
              monthly_new_enrollments, 
              monthly_returning_enrollments,
              monthly_registration_count,
              monthly_revenue
            } 
            = this.state;
      const checkboxProps = {
          selectAll,
          isSelected,
          toggleSelection,
          toggleAll,
          selectType: 'checkbox'
      }
      const formatStatValue = (value) => (value === null || value === undefined ? '-' : value.toLocaleString('en-US'))
      const formatCurrency = (value) => (value === null || value === undefined ? '-' : value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }))
      const playerRevenueYtd =
        (totalRevenue.camp || 0) +
        (totalRevenue.league || 0) +
        (totalRevenue.skillSession || 0) +
        (totalRevenue.private || 0)
      const todayLabel = new Date().toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
      const currentYear = new Date().getFullYear()
      const monthlyChartHeight = '520px'
      const donutChartHeight = '230px'

    return (
      <div className="full-page">
          <HamburgerNavbar/>
          <div className="dashboard-header-shell">
            <div className="programs-page-hero dashboard-page-hero">
              <div className="programs-page-copy">
                <div className="programs-page-kicker">{todayLabel}</div>
                <h2 className="pagetitle programs-page-title">
                  <span>Organization Dashboard</span>
                </h2>
              </div>
              <div className="programs-page-stats programs-page-stats-inline">
                <div className="programs-stat programs-stat-group">
                  <div className="programs-stat-group-header">
                    <span className="programs-stat-label">Today</span>
                  </div>
                  <div className="programs-stat-group-grid">
                    <div className="programs-stat-group-item">
                      <span className="programs-stat-group-item-label">Reg.</span>
                      <span className="programs-stat-group-item-value">{formatStatValue(this.state.today_registration_count)}</span>
                    </div>
                    <div className="programs-stat-group-divider" />
                    <div className="programs-stat-group-item">
                      <span className="programs-stat-group-item-label">Gross Rev.</span>
                      <span className="programs-stat-group-item-value">{formatCurrency(this.state.today_revenue)}</span>
                    </div>
                  </div>
                </div>
                <div className="programs-stat programs-stat-group">
                  <div className="programs-stat-group-header">
                    <span className="programs-stat-label">Month-to-Date</span>
                  </div>
                  <div className="programs-stat-group-grid">
                    <div className="programs-stat-group-item">
                      <span className="programs-stat-group-item-label">Reg.</span>
                      <span className="programs-stat-group-item-value">{formatStatValue(monthly_registration_count)}</span>
                    </div>
                    <div className="programs-stat-group-divider" />
                    <div className="programs-stat-group-item">
                      <span className="programs-stat-group-item-label">Gross Rev.</span>
                      <span className="programs-stat-group-item-value">{formatCurrency(monthly_revenue)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-wrapper" style={{ paddingTop: "0" }}>  
            <div>
              <Row style={{ display: "flex", flexWrap: "wrap", marginBottom: "2%", alignItems: "stretch" }}>

                      <Col lg={3} sm={3} xs={12} style={{ display: "flex", flexDirection: "column" }} >
                        <div className="dashboard-box" style={{ flex: 1 }}>

                                <div className="dbheadingdonut" style={{ paddingTop: "5%",}}>Enrol Goal Report</div>
                                  <Chart
                                      chartTitle="DonutChart"
                                      chartType="PieChart"
                                      width="100%"                     
                                      height={donutChartHeight}
                                      data={this.getEnrolledvsGoal()}
                                      options={{
                                        slices: {
                                          0 :{ color: colors.enrolled },
                                          1: { color: colors.goal }
                                        },
                                        titleTextStyle: {
                                          color: "#18191F",
                                          fontSize: 18,
                                          textAlign: "center",
                                        },
                                        pieHole: 0.5,
                                        pieStartAngle: 0,
                                        backgroundColor: { fill: 'transparent'},
                                        pieSliceBorderColor: 'transparent',
                                        legend: {
                                          position: 'bottom',
                                          textStyle: {
                                            color: "#18191F",
                                          }
                                        }
                                      }}
                                    />  

                                <div className="dbheadingdonut">Status Report</div>                
                                  <Chart
                                          chartTitle="DonutChart"
                                          chartType="PieChart"
                                          width="100%"
                                          height={donutChartHeight}
                                          data={secondDonut}
                                          options={{
                                            slices: {
                                              0: { color: colors.enrolled },
                                              1: { color: colors.waitlist }, 
                                              2: { color: colors.invited }
                                            },
                                            titleTextStyle: {
                                              color: "black",
                                              fontSize: 14
                                            },
                                            pieHole: 0.5,
                                            pieStartAngle: 0,
                                            backgroundColor: { fill: 'transparent' },
                                            pieSliceBorderColor: 'transparent',
                                            legend: {
                                              position: 'bottom',
                                              textStyle: {
                                                color: "black"
                                              }
                                            }
                                          }}
                                        />   
                        </div>                                                                                     

                      </Col>

                      <Col lg={6} sm={6} xs={12} style={{ display: "flex", flexDirection: "column" }}>

                        <div className="dashboard-box" style={{ flex: 1 }}>
                
                          <div className="dbheadingmonthly" style={{ paddingTop: "2%", paddingBottom: "2%" }} >Registration Tracker</div> 

                              <Chart graph_id="ColumnChart"
                              width="100%"
                              height={monthlyChartHeight}
                              legend_toggle
                                chartType="ColumnChart"
                                data={[
                                  ["Type", "Returning", "New", { "role": "annotation" }],
                                  [`${getMonth[1]}`,
                                    monthly_returning_enrollments[1],
                                    monthly_new_enrollments[1], ""],
                                  [`${getMonth[2]}`,
                                    monthly_returning_enrollments[2],
                                    monthly_new_enrollments[2], ""],
                                  [`${getMonth[3]}`,
                                    monthly_returning_enrollments[3],
                                    monthly_new_enrollments[3], ""],
                                  [`${getMonth[4]}`,
                                    monthly_returning_enrollments[4],
                                    monthly_new_enrollments[4], ""],
                                  [`${getMonth[5]}`,
                                    monthly_returning_enrollments[5],
                                    monthly_new_enrollments[5], ""],
                                  [`${getMonth[6]}`,
                                    monthly_returning_enrollments[6],
                                    monthly_new_enrollments[6], ""],
                                  [`${getMonth[7]}`,
                                    monthly_returning_enrollments[7],
                                    monthly_new_enrollments[7], ""],
                                  [`${getMonth[8]}`,
                                    monthly_returning_enrollments[8],
                                    monthly_new_enrollments[8], ""],
                                  [`${getMonth[9]}`,
                                    monthly_returning_enrollments[9],
                                    monthly_new_enrollments[9], ""],
                                  [`${getMonth[10]}`,
                                    monthly_returning_enrollments[10],
                                    monthly_new_enrollments[10], ""],
                                  [`${getMonth[11]}`,
                                    monthly_returning_enrollments[11],
                                    monthly_new_enrollments[11], ""],
                                  [`${getMonth[12]}`,
                                    monthly_returning_enrollments[12],
                                    monthly_new_enrollments[12], ""]
                                  ]}
                                  options={{
                                  isStacked: true,
                                  colors: [colors.returning, colors.new],
                                  backgroundColor: { fill: 'transparent' },
                                  fontSize: 14,
                                  titleTextStyle: {
                                    color: "#0f172a",
                                    fontSize: 20
                                  },
                                  legend: {
                                    position: 'bottom',
                                    textStyle: {
                                      color: "black"
                                    }
                                  },
                                  hAxis: {
                                    textStyle: {
                                      color: "black"
                                    }
                                  },
                                  vAxis: {
                                    textStyle: {
                                      color: "black"
                                    },
                                    format: '0',
                                    minValue: 0
                                  },
                                  chartArea: {
                                    left: "7%",
                                    width: "89%"
                                  }
                                }}
                              />
                        </div>

                      </Col>  

                      <Col lg={3} sm={3} xs={9} style={{ display: "flex", flexDirection: "column" }}>

                          <div className="dashboard-box" style={{ paddingTop: "5%", paddingBottom: "2%" }}>
                           <Col>

                                <div className="dbheadingytd">Registration, {currentYear}</div>
                                <EnrolmentTracker />

                                <div className="dbheadingat">Registration, All Time</div>
                                  <EnrolmentTracker2 />

                           </Col>                     
                          </div>                

                          <div className="dashboard-box" style={{ marginTop: "30px", paddingTop: "5%", paddingBottom: "4%" }}> 
                                <div className="dbheadingdonut">Collected Revenue YTD</div>                
                                <Chart
                                  chartTitle="DonutChart"
                                  chartType="PieChart"
                                  width="100%"
                                  height={donutChartHeight}
                                  data={[
                                    ["Type", "Value"],
                                    ["Camp", totalRevenue.camp || 0],
                                    ["League", totalRevenue.league || 0],
                                    ["Skill Session", totalRevenue.skillSession || 0],
                                    ["Private", totalRevenue.private || 0]
                                  ]}
                                  options={{
                                    slices: {
                                      0: { color: colors.camp },
                                      1: { color: colors.league },
                                      2: { color: colors.skillSession },
                                      3: { color: colors.private }
                                    },
                                    titleTextStyle: {
                                      color: "#0f172a",
                                      fontSize: 14
                                    },
                                    pieHole: 0.5,
                                    pieStartAngle: 270,
                                    backgroundColor: { fill: 'transparent' },
                                    pieSliceBorderColor: 'transparent',
                                    legend: {
                                      position: 'bottom',
                                      textStyle: {
                                        color: "#0f172a"
                                      }
                                    }
                                  }}
                                />
                          </div>     

                      </Col> 

                </Row>                                     

                <Row>

                    <Col lg={12} sm={12} xs={12} className="dashboard-box"  >
                      {this.state.loading_transactions && <small style={{padding: "10px"}}>Loading all-time data...</small>}
                          <CheckboxTable
                            ref={(r) => this.checkboxTable = r}
                            data={data}
                            defaultFilterMethod={this.filterMethod}
                            columns={[
                              { Header: "Season", accessor: "season", filterable: true, Placeholder: "Search" },
                              { Header: "Type", accessor: "type", filterable: true },
                              { Header: "Ages", accessor: "ages", filterable: true },
                              { Header: "Division", accessor: "division", filterable: true, width: 70 },
                              { Header: "Group", accessor: "group_name", filterable: true, width: 325 },
                              { Header: "Enrolled", accessor: "enrollment_total", filterable: true, width: 70 },
                              { Header: "Waitlist", accessor: "enrollment_waitlist", filterable: true, width: 70 },
                              { Header: "Invited", accessor: "enrollment_invited", filterable: true, width: 70 },                        
                              // { Header: "Enrol Goal", accessor: "enrollment_goal", filterable: true },
                              // { Header: "Enrol Max", accessor: "enrollment_maximum", filterable: true },
                              // { Header: `${merch_map[0].name} sold`, accessor: "item_0_count", filterable: true },
                              // { Header: `${merch_map[1].name} sold`, accessor: "item_1_count", filterable: true },
                              // { Header: `${merch_map[2].name} sold`, accessor: "item_2_count", filterable: true },
                              // { Header: "Payment Plan", accessor: "payment_plan", filterable: true },
                              // { Header: "H. Coach", accessor: "head_coach", filterable: true },
                              { Header: "Starts", accessor: "start_date", filterable: true },
                              { Header: "Ends", accessor: "end_date", filterable: true },                         
                              { Header: "Enrol. Opens", accessor: "registration_start_date", filterable: true },
                              { Header: "Enrol. Closes", accessor: "registration_end_date", filterable: true },                                            
                              // { Header: "Costs", accessor: "expected_costs", filterable: true },
                              // { Header: "Profits", accessor: "projected_program_profits", filterable: true }
                            ]}
                            defaultPageSize={15}
                            className="-striped -highlight"
                            {...checkboxProps}
                          />

                    </Col>

                </Row>
            </div>
          </div>      
                              
      </div>
      );
  }
}

export default AdminPortalDashboard
